import { Component, computed, inject, input, output } from '@angular/core'
import { RouterLink } from '@angular/router'

import { ButtonModule } from 'primeng/button'
import { RippleModule } from 'primeng/ripple'

import { ConfigStore } from 'app/store/config.store'

type ButtonStyleType = 'primary' | 'secondary' | 'outlined' | 'text' | 'danger' | 'disabled'
type ButtonType = 'button' | 'submit'
type IconPosition = 'left' | 'right'

@Component({
  selector: 'app-button',
  imports: [RouterLink, ButtonModule, RippleModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  private readonly configStore = inject(ConfigStore)

  protected readonly buttonSettings = computed(() => this.configStore.config().settings)

  linkTo = input<string>()
  icon = input<string>('')
  buttonClassName = input<string>('')
  label = input.required<string>()
  buttonStyle = input<ButtonStyleType>('primary')
  type = input<ButtonType>('button')
  iconPosition = input<IconPosition>('left')
  fullWidth = input<boolean>()
  disabled = input<boolean>(false)
  loading = input<boolean>(false)
  handleClick = output<MouseEvent>()

  buttonClass = computed(() => {
    switch (this.buttonStyle()) {
      case 'outlined':
        return 'button p-button-outlined'
      case 'secondary':
        return 'button p-button-secondary'
      case 'text':
        return 'p-button-text'
      case 'danger':
        return 'button p-button-danger'
      case 'disabled':
        return 'button p-button-disabled'
      default:
        return 'button'
    }
  })

  handleClickEvent($event: MouseEvent) {
    if (!this.disabled()) {
      this.handleClick.emit($event)
    }
  }
}
